import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subject, takeUntil } from 'rxjs';

import { IPaperTemplatesData } from 'editing-tool/src/app/shared/components/paper/steps/templates/paper-templates-data';
import { FileResponse, FileUtils, WindowRefService } from 'sc-common';

type PaperTemplateEntry = Readonly<{
    name: string;
    icon: string;
    externalUrl$?: Observable<string>;
    downloadFileExpression?: () => Observable<FileResponse>;
}>;

@Component({
    selector: 'et-paper-templates',
    templateUrl: './paper-templates.component.html',
    styleUrls: ['paper-templates.component.scss'],
    standalone: false
})
export class PaperTemplatesComponent implements OnInit, OnDestroy {

    @Input()
    public data: IPaperTemplatesData;

    public templates: PaperTemplateEntry[] = [];

    private readonly _destroy$ = new Subject<void>();

    constructor(private readonly _windowRefService: WindowRefService) {
    }

    public ngOnInit(): void {

        this.templates = [
            {
                name: $localize`Download Docx Template`,
                icon: 'far fa-file-word fa-4x',
                downloadFileExpression: () => this.data.docxTemplate$
            },
            {
                name: $localize`Download LaTeX Template`,
                icon: 'far fa-file-archive fa-4x',
                downloadFileExpression: () => this.data.latexTemplate$
            },
            {
                name: $localize`Use LaTeX Template on OverLeaf`,
                icon: 'fas fa-link fa-4x',
                externalUrl$: this.data.latexOnOverleafUrl$
            }
        ];
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public onTemplateClick(template: PaperTemplateEntry): void {
        if (template.downloadFileExpression) {
            template.downloadFileExpression()
                .pipe(takeUntil(this._destroy$))
                .subscribe(result => FileUtils.save(result));
        } else {
            template.externalUrl$
                .pipe(takeUntil(this._destroy$))
                .subscribe(url => this._windowRefService.nativeWindow.open(url));
        }
    }
}
